import store from '@/store';

import { INITIALIZE_FROM_COOKIES_AC, SET_REDIRECT_ACT } from '@/store/auth/actions.type';
import { SET_EMPRESA_ACTION } from '@/store/premium/actions.type';

import Main from '@/modules/main/Main.vue';
import Header from '@/modules/header/Header.vue';
import Cotacoes from '@/modules/cotacoes/Cotacoes.vue';
import MeuPainel from '@/modules/meu-painel/MeuPainel.vue';
import MinhaConta from '@/modules/minha-conta/MinhaConta.vue';
import MinhaEmpresa from '@/modules/minha-empresa/MinhaEmpresa.vue';
import CotacaoDetalhes from '@/modules/cotacoes/detalhes/CotacaoDetalhes.vue';
import RespostaCotacao from '@/modules/cotacoes/resposta/RespostaCotacao.vue';
import MInhaResposta from '@/modules/cotacoes/resposta/minha-resposta/MInhaResposta.vue';
import LocaisColeta from '@/modules/locais-coleta/LocaisColeta.vue';
import PainelCotacoes from '@/modules/painel-cotacoes/PainelCotacoes.vue';
import ContratacaoListagem from '@/modules/contratacoes/lista/ContratacaoListagem.vue';
import ContratacaoDetalhes from '@/modules/contratacoes/detalhes/ContratacaoDetalhes.vue';

import TransportadoraService from '@/api/transportador-service';

const getTransportadora = () => TransportadoraService.get()
  .then(({ data }) => {
    const [empresa] = data;
    store.dispatch(SET_EMPRESA_ACTION, empresa);
    return empresa;
  });

const beforeEnterAuth = (to, from, next) => {
  if (!store.getters.isAuthenticated) {
    if (store.getters.tokenFromStorage) {
      store.dispatch(INITIALIZE_FROM_COOKIES_AC);
      return getTransportadora()
        .then(() => next());
    }
    store.dispatch(SET_REDIRECT_ACT, to.fullPath);
    return next('/login');
  }
  return getTransportadora()
    .then(() => next());
};

export default {
  path: '/',
  name: 'main',
  redirect: { name: 'main.meu-painel' },
  components: {
    default: Main,
    header: Header,
  },
  children: [
    {
      path: 'cotacoes',
      name: 'main.cotacoes',
      components: {
        default: Cotacoes,
      },
    },
    {
      path: 'cotacoes/:id',
      name: 'main.cotacoes.detalhes',
      components: {
        default: CotacaoDetalhes,
      },
    },
    {
      path: 'cotacoes/:id/responder',
      name: 'main.cotacoes.resposta',
      components: {
        default: RespostaCotacao,
      },
    },
    {
      path: 'cotacoes/:id/minha-resposta/:idResposta',
      name: 'main.cotacoes.resposta.minha',
      components: {
        default: MInhaResposta,
      },
    },
    {
      path: 'contratacoes',
      name: 'main.contratacoes',
      components: {
        default: ContratacaoListagem,
      },
    },
    {
      path: 'contratacoes/:id',
      name: 'main.contratacoes.detalhes',
      components: {
        default: ContratacaoDetalhes,
      },
    },
    {
      path: 'painel',
      name: 'main.painel-cotacoes',
      components: {
        default: PainelCotacoes,
      },
    },
    {
      path: 'meu-painel',
      name: 'main.meu-painel',
      components: {
        default: MeuPainel,
      },
    },
    {
      path: 'minha-conta',
      name: 'main.minha-conta',
      components: {
        default: MinhaConta,
      },
    },
    {
      path: 'minha-empresa',
      name: 'main.minha-empresa',
      components: {
        default: MinhaEmpresa,
      },
    },
    {
      path: 'locais-coleta',
      name: 'main.locais-coleta',
      components: {
        default: LocaisColeta,
      },
    },
  ],
  beforeEnter: beforeEnterAuth,
};
